<script>
import options from './FlowEditModal.options'
export default options
</script>

<template>
  <article v-if="!changesSaved" class="kb-flow-edit-modal">
    <section class="kb-flow-edit-modal__hero">
      <h1 class="kb-flow-edit-modal__hero__title">
        {{ getLabel('header') }}
      </h1>
    </section>
    <div class="kb-flow-edit-modal__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z"
        />
      </svg>
    </div>
    <section class="kb-flow-edit-modal__content-container">
      <p class="kb-flow-edit-modal__content-container__text">
        {{ getLabel('textContent') }}
      </p>
      <div class="kb-flow-edit-modal__button-wrapper">
        <button
          @click="saveChanges"
          id=""
          name="submit"
          type="submit"
          value=""
          class="kb-button kb-button--full-color-spot"
        >
          {{ getLabel('saveChangesButton') }}
        </button>
        <button
          @click="closeModal"
          id=""
          name="submit"
          type="submit"
          value=""
          class="kb-button"
        >
          {{ getLabel('noSaveButton') }}
        </button>
      </div>
    </section>
  </article>

  <article v-else class="kb-flow-edit-modal">
    <section class="kb-flow-edit-modal__hero">
      <h1 class="kb-flow-edit-modal__hero__title">
        {{ getLabel('savedChangesHeader') }}
      </h1>
    </section>
    <div class="kb-flow-edit-modal__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z"
        />
      </svg>
    </div>
    <section class="kb-flow-edit-modal__content-container">
      <p class="kb-flow-edit-modal__content-container__text">
        {{ getLabel('SavedChangesTextContent') }}
      </p>
      <div class="kb-flow-edit-modal__button-wrapper">
        <button
          @click="closeModal"
          id=""
          name="submit"
          type="submit"
          value=""
          class="kb-button kb-button--full-color-spot"
        >
          {{ getLabel('closeButton') }}
        </button>
      </div>
    </section>
  </article>
</template>
